import {
    Avatar,
    Button,
    Drawer,
    Tabs,
    Tag,
} from "antd";

import {
    Calendar,
    FileText,
    MessageCircle,
    Phone,
    PhoneOff,
    X,
} from "lucide-react";
import TimelineTab from "./TimelineTab";
import CsatTab from "./CsatTab";
import GalleryTab from "./GalleryTab";
import { useState } from "react";

export default function CustomerCareDrawer({
    open,
    onClose,
    customer,
    onUpdated,
}: any) {
    const [isSoftphoneOpen, setIsSoftphoneOpen] = useState(false);
    const [agentStatus, setAgentStatus] = useState({ state: 'ONLINE', colorClass: 'green' });

    const Icons = {
        Users: () => <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"></path></svg>,
        Search: () => <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path></svg>,
        Phone: () => <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path></svg>,
        ArrowUp: () => <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 10l7-7m0 0l7 7m-7-7v18"></path></svg>,
        ArrowDown: () => <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 14l-7 7m0 0l-7-7m7 7V3"></path></svg>,
        PhoneMissed: () => <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 3l18 18M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path></svg>,
        PhoneOff: () => <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"></path></svg>,
        UserSecret: () => <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 11c0 3.517-1.009 6.799-2.753 9.571m-3.44-2.04l.054-.09A13.916 13.916 0 008 11a4 4 0 118 0c0 1.017-.07 2.019-.203 3m-2.118 6.844A21.88 21.88 0 0015.171 17m3.839 1.132c.645-2.266.99-4.659.99-7.132A8 8 0 008 4.07M3 15.364c.64-1.319 1-2.8 1-4.364 0-1.457.39-2.823 1.07-4"></path></svg>,
        Play: () => <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"></path><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>,
        ChatDots: () => <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"></path></svg>,
        Calendar: () => <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path></svg>,
        Headset: () => <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M20 11.696V10a8 8 0 10-16 0v1.696A4.001 4.001 0 003 15v3a2 2 0 002 2h1a2 2 0 002-2v-3a2 2 0 00-2-2v-1.696A5.98 5.98 0 0112 6a5.98 5.98 0 017 4.304V12a2 2 0 00-2 2v3a2 2 0 002 2h1a2 2 0 002-2v-3a4.001 4.001 0 00-1-3.304z"></path></svg>,
        Times: () => <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path></svg>,
        Backspace: () => <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2M3 12l6.414 6.414a2 2 0 001.414.586H19a2 2 0 002-2V7a2 2 0 00-2-2h-8.172a2 2 0 00-1.414.586L3 12z"></path></svg>
    };
    const [callState, setCallState] = useState('idle');
    const [dialerInput, setDialerInput] = useState('');
    const [currentTicketContext, setCurrentTicketContext] = useState(null);
    const [callingNumber, setCallingNumber] = useState('');
    const [callingName, setCallingName] = useState('');
    const [callDuration, setCallDuration] = useState(0);
    const [callLogs, setCallLogs] = useState([]);


    const handleMakeCall = (phone, name, ticketContext = null) => {
        setCurrentTicketContext(ticketContext);
        setIsSoftphoneOpen(true);
        setDialerInput(phone);
        handleStartCall(phone, name);
    };

    const handleStartCall = (phone, name) => {
        if (!phone) return;
        setCallingNumber(phone);
        setCallingName(name || 'Khách hàng');
        setCallState('calling');
        setTimeout(() => {
            setCallState('connected');
        }, 2000);
    };

    const handleEndCall = () => {
        setCallState('ended');
        const timeStr = new Date().toLocaleTimeString('vi-VN', { hour: '2-digit', minute: '2-digit' });
        const formatDuration = (seconds) => {
            const m = Math.floor(seconds / 60).toString().padStart(2, '0');
            const s = (seconds % 60).toString().padStart(2, '0');
            return `${m}:${s}`;
        };

        const newLog = {
            id: Date.now(),
            name: callingName,
            time: timeStr,
            duration: formatDuration(callDuration),
            ticketContext: currentTicketContext
        };

        setCallLogs(prev => [newLog, ...prev]);

        setTimeout(() => {
            setCallState('idle');
            setDialerInput('');
            setCurrentTicketContext(null);
        }, 1000);
    };

    const formatDurationDisplay = (seconds) => {
        const m = Math.floor(seconds / 60).toString().padStart(2, '0');
        const s = (seconds % 60).toString().padStart(2, '0');
        return `${m}:${s}`;
    };

    return (
        <Drawer
            open={open}
            onClose={onClose}
            placement="right"
            width={600}
            closable={false}
            maskClosable
            destroyOnClose
            rootStyle={{
                height: "100vh",
            }}
            styles={{
                body: {
                    padding: 0,
                    overflow: "hidden",
                },
            }}
        >
            <div className="flex h-full flex-col">
                {/* Header */}

                <div className="border-b p-6">

                    <div className="flex justify-between">

                        <div className="flex gap-4">

                            <Avatar
                                size={56}
                                style={{
                                    background: "#F3E8FF",
                                    color: "#9333EA",
                                    fontSize: 28,
                                    fontWeight: 700,
                                }}
                            >
                                {customer?.avatar}
                            </Avatar>

                            <div>

                                <div className="flex items-center gap-2">

                                    <h2 className="text-[18px] font-semibold leading-none text-000000e0">
                                        {customer?.name}
                                    </h2>

                                    <Tag
                                        color={customer?.is_cared ? "success" : "warning"}
                                        className="!text-[10px] !px-1.5 !py-0 rounded"
                                    >
                                        {customer?.status}
                                    </Tag>

                                </div>

                                <div className="space-y-1 mt-2 text-[13px] text-slate-600">

                                    <div className="flex gap-2 items-center">
                                        <Phone size={14} />
                                        {customer?.phone}
                                    </div>

                                    <div className="flex gap-2 items-center">
                                        <FileText size={14} />
                                        Mã lịch hẹn: {customer?.code}
                                    </div>

                                    <div className="flex gap-2 items-center text-blue-600">
                                        <Calendar size={14} />
                                        Dịch vụ đã làm: {customer?.service}
                                    </div>

                                </div>

                            </div>

                        </div>

                        <Button
                            shape="circle"
                            icon={<X size={16} />}
                            onClick={onClose}
                        />

                    </div>

                </div>

                {/* Action — giao diện chờ API (gọi điện/Zalo/Messenger), sẽ nối khi backend bổ sung */}

                <div className="grid grid-cols-3 gap-3 p-5 border-b">

                    <Button
                        onClick={() => handleMakeCall('0909866868', 'Mr.Boss')}
                        className="h-[54px] bg-green-50 text-[13px] flex flex-col items-center justify-center gap-1 p-2 rounded-lg bg-green-50 text-green-700 hover:!bg-green-100 transition-colors border-none"
                        icon={<Phone size={18} />}
                    >
                        Gọi điện
                    </Button>

                    <Button
                        className="h-[54px] text-[13px] flex flex-col items-center justify-center gap-1 p-2 rounded-lg bg-blue-50 text-blue-700 hover:!bg-blue-100 transition-colors border-none"
                        icon={<MessageCircle size={18} />}
                    >
                        Zalo
                    </Button>

                    <Button
                        className="h-[54px] text-[13px] border-none flex flex-col items-center justify-center gap-1 p-2 rounded-lg bg-indigo-50 text-indigo-700 hover:!bg-indigo-100 transition-colors"
                        icon={<MessageCircle size={18} />}
                    >
                        Messenger
                    </Button>

                </div>

                {/* Softphone Modal */}
                <div className={`fixed bottom-6 right-6 w-72 bg-white rounded-xl shadow-[0_10px_40px_-10px_rgba(0,0,0,0.3)] border border-gray-200 z-50 transition-transform duration-300 transform flex flex-col overflow-hidden ${isSoftphoneOpen ? 'translate-y-0' : 'translate-y-[120%]'}`}>
                    <div className="bg-gray-900 text-white p-3 flex justify-between items-center cursor-move">
                        <div className="flex items-center gap-2">
                            <span className="text-blue-400"><Icons.Headset /></span>
                            <span className="font-semibold text-sm">MiCall Extension</span>
                        </div>
                        <div className="flex items-center gap-2">
                            <div className={`w-2 h-2 rounded-full bg-${agentStatus.colorClass === 'gray' ? 'red' : 'green'}-500`}></div>
                            <button onClick={() => setIsSoftphoneOpen(false)} className="text-gray-400 hover:text-white"><Icons.Times /></button>
                        </div>
                    </div>

                    {callState === 'idle' ? (
                        <div className="p-4 flex flex-col items-center">
                            <input type="text" value={dialerInput} onChange={(e) => setDialerInput(e.target.value)} placeholder="Nhập số điện thoại..." className="w-full text-center text-lg font-bold text-000000e0 border-b-2 border-gray-200 focus:border-blue-500 focus:outline-none pb-2 mb-4 bg-transparent" />

                            <div className="grid grid-cols-3 gap-3 w-full px-2 mb-4">
                                {['1', '2', '3', '4', '5', '6', '7', '8', '9', '*', '0'].map(num => (
                                    <button key={num} onClick={() => setDialerInput(prev => prev + num)} className="h-10 rounded bg-gray-100 hover:bg-gray-200 font-semibold text-000000e0">{num}</button>
                                ))}
                                <button onClick={() => setDialerInput(prev => prev.slice(0, -1))} className="h-10 rounded bg-gray-100 hover:bg-gray-200 text-000000e0 flex items-center justify-center"><Icons.Backspace /></button>
                            </div>
                            <button onClick={() => handleStartCall(dialerInput, 'Không xác định')} className="w-12 h-12 rounded-full bg-green-500 hover:bg-green-600 text-white flex items-center justify-center text-xl shadow transition transform hover:scale-105">
                                <Icons.Phone />
                            </button>
                        </div>
                    ) : (
                        <div className="p-6 flex flex-col items-center bg-gray-900 text-white relative">
                            {callState === 'calling' && (
                                <div className="absolute inset-0 opacity-20 pointer-events-none flex items-center justify-center">
                                    <div className="w-32 h-32 rounded-full border-2 border-green-500 pulse-ring"></div>
                                </div>
                            )}
                            <h4 className="text-gray-400 text-xs mb-1 z-10">
                                {callState === 'calling' ? 'Đang kết nối...' : callState === 'connected' ? 'Đang đàm thoại' : 'Đã kết thúc'}
                            </h4>
                            <h2 className="text-xl font-bold mb-1 z-10">{callingNumber}</h2>
                            <p className="text-xs text-gray-300 mb-4 z-10">{callingName}</p>
                            <div className="w-32 h-32 rounded-full border-2 border-green-500 pulse-ring flex items-center justify-center mb-4 relative">
                                <div className={`text-2xl font-mono z-10 ${callState === 'connected' ? 'text-green-400' : 'text-gray-500'}`}>
                                    {formatDurationDisplay(callDuration)}
                                </div>
                            </div>
                            <button onClick={handleEndCall} disabled={callState === 'ended'} className={`w-12 h-12 rounded-full flex items-center justify-center text-xl shadow transition z-10 ${callState === 'ended' ? 'bg-gray-600 cursor-not-allowed' : 'bg-red-500 hover:bg-red-600 hover:scale-105'}`}>
                                <PhoneOff size={20} color="#fff" />
                            </button>
                        </div>
                    )}
                </div>

                <div className="flex-1 overflow-hidden">
                    <Tabs
                        defaultActiveKey="timeline"
                        className="customer-care-tabs flex-1"
                    >

                        <Tabs.TabPane
                            tab="Hành trình (Timeline)"
                            key="timeline"
                        >
                            <TimelineTab appointmentId={customer?.id} />
                        </Tabs.TabPane>

                        <Tabs.TabPane
                            tab="Khảo sát CSAT"
                            key="csat"
                        >
                            <CsatTab
                                appointmentId={customer?.id}
                                survey={customer?.survey_data}
                                isCared={customer?.is_cared}
                                caredBy={customer?.cared_by_staff_name}
                                caredAt={customer?.cared_at}
                                onUpdated={onUpdated}
                            />
                        </Tabs.TabPane>

                        <Tabs.TabPane
                            tab="Hình ảnh (Gallery)"
                            key="gallery"
                        >
                            <GalleryTab appointmentId={customer?.id} />
                        </Tabs.TabPane>

                    </Tabs>
                </div>
            </div>
        </Drawer>
    );
}
